const checkRequiredProps = (
  obj: object | null | undefined,
  requiredProps: Array<string>
) => {
  if (!obj) {
    throw new Error('Invalid config: passed config is null or undefined')
  }
  requiredProps.forEach((prop) => {
    if (!Object.prototype.hasOwnProperty.call(obj, prop)) {
      console.error(obj) // eslint-disable-line
      throw new Error(`Invalid config: missing required field "${prop}"`)
    }
  })
}

export default checkRequiredProps
